/**
 * Two top-level chat-convergence destinations. Deliberately mirrors the search-page
 * `PageMode` (`'search' | 'chat'`) so the routed `?mode=` query param maps 1:1.
 *
 * Lives in `common` (not the `ui` chat-intent-router folder) so the analytics event
 * helper can reference the type without `common` importing from `ui`.
 */
export const ChatIntentMode = { CHAT: 'chat', SEARCH: 'search' } as const;
export type ChatIntentMode = (typeof ChatIntentMode)[keyof typeof ChatIntentMode];
